import React, {FunctionComponent} from 'react'
import {Navbar} from "@App/Components/Navbar";
import {Footer} from "@App/Layouts/Footer";
import {Outlet} from "react-router-dom";
import {State} from "@App/state";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

export const Layout: FunctionComponent = () => {
    const organization = useSelector((state: State) => state.orders.organization)
    const {t} = useTranslation()

    return (
        <div className="text-neutral-400">
            <Outlet/>
        </div>
    )
}
